// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Yasn","filesListContainer":"PosDisputesFiles_filesListContainer__1NFfy","filesButton":"PosDisputesFiles_filesButton__3JWH-"};